import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteData,
  type DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteError,
  type DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteResponse,
  deletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDelete,
} from '../../generated';

export type DeletePdpMutationVariables = DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteData['path'];

export type DeletePdpMutation = DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteResponse;

export const useDeletePdpMutation = <TError = DeletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDeleteError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<DeletePdpMutation, TError, DeletePdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeletePdpMutation, TError, DeletePdpMutationVariables, TContext>({
    mutationKey: ['DeletePdp'],
    mutationFn: async ({ workspace_id, pdp_id }: DeletePdpMutationVariables) => {
      const { data } = await deletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDelete({
        path: { workspace_id, pdp_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeletePdpMutation.fetcher = (
  { workspace_id, pdp_id }: DeletePdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deletePdpV1WorkspacesWorkspaceIdPdpsPdpIdDelete({
      path: { workspace_id, pdp_id },
      throwOnError: true,
    });
    return data;
  };
};
